import React from "react";
import {
  Award,
  BadgeCheck,
  Calendar,
  Home as HomeIcon,
  Shield,
  Star,
  Users,
} from "lucide-react";
import { Container } from "./Container";
import { Reveal } from "./Reveal";
import { TEAM_BAND, TEAM_PHOTO } from "../../lib/content";
import { IconBadge } from "./IconBadge";

const STAT_ICONS = {
  Calendar,
  Award,
  Home: HomeIcon,
  Shield,
  BadgeCheck,
  Star,
};

export const TeamBand = () => (
  <section
    id="team"
    data-testid="section-team"
    className="bg-white"
  >
    <Container className="py-24 md:py-32">
      <div className="grid lg:grid-cols-12 gap-10 lg:gap-16 items-center">
        {/* Photo with overlay */}
        <Reveal className="lg:col-span-7" delay={0.05}>
          <div className="relative">
            <div
              className="aspect-[4/3] w-full rounded-xl overflow-hidden border border-border bg-muted"
              data-testid="team-image-frame"
            >
              <img
                src={TEAM_PHOTO}
                alt="Dan and the QVolt Solar install team on a Queensland rooftop"
                width={545}
                height={545}
                loading="lazy"
                decoding="async"
                referrerPolicy="no-referrer"
                className="w-full h-full object-cover"
                data-testid="team-image"
              />
            </div>
            <div
              className="absolute top-4 left-4 inline-flex items-center gap-2 bg-white border border-border rounded-xl shadow-sm px-3.5 py-2"
              data-testid="team-image-overlay"
            >
              <IconBadge icon={Users} size="sm" className="rounded-lg" />
              <span className="text-[13px] font-medium text-ink">
                Family-owned, Queensland
              </span>
            </div>
          </div>
        </Reveal>

        {/* Copy */}
        <Reveal className="lg:col-span-5" delay={0.1}>
          <div className="qv-eyebrow text-brand-blue mb-4">
            {TEAM_BAND.eyebrow}
          </div>
          <h2 className="qv-h2" data-testid="team-headline">
            {TEAM_BAND.headline}
          </h2>
          <p
            className="qv-lead mt-5 text-ink/80"
            data-testid="team-body"
          >
            {TEAM_BAND.body_verbatim}
          </p>
          <ul
            className="mt-7 flex flex-wrap gap-2"
            data-testid="team-stats"
          >
            {TEAM_BAND.stats.map((s, i) => {
              const Icon = STAT_ICONS[s.icon] || Star;
              return (
                <li
                  key={s.label}
                  className="inline-flex items-center gap-2 px-3.5 h-9 rounded-full bg-muted border border-border text-[13px] text-ink"
                  data-testid={`team-stat-${i}`}
                >
                  <Icon
                    className="h-3.5 w-3.5 text-brand-blue"
                    strokeWidth={1.75}
                  />
                  {s.label}
                </li>
              );
            })}
          </ul>
        </Reveal>
      </div>
    </Container>
  </section>
);

export default TeamBand;
